import { render, staticRenderFns } from "./TogSubDialog.vue?vue&type=template&id=0c58a03e&scoped=true"
import script from "./TogSubDialog.vue?vue&type=script&lang=js"
export * from "./TogSubDialog.vue?vue&type=script&lang=js"
import style0 from "./TogSubDialog.vue?vue&type=style&index=0&id=0c58a03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58a03e",
  null
  
)

export default component.exports